import $ from 'jquery';

class Authentication {
    constructor() {
        this.events();
    }

    events() {
        $("#loginEmailForm").on("submit", this.loginDefault.bind(this));
        $("#signUpEmailForm").on("submit", this.signUpDefault.bind(this));
        $("#send-pin-form").on("submit", this.sendPIN.bind(this));
        $("#forgot-pass-form").on("submit", this.forgotPass.bind(this));
        $("#update-pass-form").on("submit", this.updatePass.bind(this));
        $("#pincode-field-main").on("keyup", ".pincode-field", this.pinInput.bind(this));
        $('#option_send').on("change",this.showMobileNumberField.bind(this));
        $('#country-phone-number').on("change",this.assignCountryCode.bind(this));
        $('#phone_number_field').on("keydown", "input[name=\"phone_number\"]", this.avoidDeletionCountryCode.bind(this));
        
    }

    updatePass(e){
        e.preventDefault();
        var thisForm = $(e.target);
        const thisBtn = thisForm.find('button');
        const form = document.getElementById('update-pass-form');
        const submitButton = document.getElementById('update_pass_submit');

        thisForm.find('.error').hide();
        thisForm.find('.invalid-feedback').remove();
        thisBtn.prop("disabled",true);
        thisBtn.find(".indicator-label").hide();
        thisBtn.find(".indicator-progress").show();

        var validator = FormValidation.formValidation(
            form,
            {
                fields: {
                    'new_password': {
                        validators: {
                            notEmpty: {
                                message: 'The password is required'
                            },
                            stringLength: {
                                min: 8,
                                max: 30,
                                message: 'The password must be more than 8 and less than 30 characters long'
                            },
                            callback: {
                                message: 'Please enter valid password',
                                callback: function (input) {
                                    if (input.value.length > 0) {
                                        return validatePassword();
                                    }
                                }
                            }
                        }
                    },
                    'confirm_password': {
                        validators: {
                            notEmpty: {
                                message: 'The password confirmation is required'
                            },
                            identical: {
                                compare: function () {
                                    return form.querySelector('[name="new_password"]').value;
                                },
                                message: 'The password and its confirm are not the same'
                            }
                        }
                    }
                },
        
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',
                        eleValidClass: ''
                    })
                }
            }
        );

        if(validator){
                validator.validate().then(function (status) {
                    if(status === 'Valid'){

                    var formData = {
                        "action":"updatepass",
                        "password":$('#new_password').val(),
                        "confirm_password":$('#confirm_password').val(),
                        "code":$('#code').val(),
                        "language":ootlahData.language,
                        "nonce": $('#update_pass_nonce').val()
                    };

                    $.ajax({
                        beforeSend: (xhr) => {
                            xhr.setRequestHeader('X-WP-Nonce',ootlahData.nonce);
                        },
                        dataType: "json",
                        url: ootlahData.root_url + '/wp-admin/admin-ajax.php',
                        type: 'POST',
                        data: formData,
                        success: (response) => {
                            if(response.result=="success"){
                                $('#forgot-pass-form-section').html(`
        <p class="text-center mb-4">Password successfully updated. Login now and start booking your activities!</p>
        <div class="text-center"><a href="${ootlahData.root_url+"/"+ootlahData.language}/login.html" class="btn ootlah-btn-primary">Login Now</button></div>`);

                            }else{
                                $.each(response.errors,function(key,value){
                                    if (value != "") {
                                        jQuery(".error-"+key).show();
                                        jQuery(".error-"+key).find('span.text').text(value);
                                    }
                                });
                            }

                            thisBtn.prop("disabled",false);
                            thisBtn.find(".indicator-label").show();
                            thisBtn.find(".indicator-progress").hide();
                            
                        },
                        error: (response) => {
                            console.log("Sorry");
                            console.log(response);
                        }
                    });

                }else{
                    Swal.fire({
                        text: "Error found. Please check.",
                        icon: "error",
                        buttonsStyling: false,
                        confirmButtonText: "Ok, got it!",
                        customClass: {
                            confirmButton: "btn btn-danger"
                        }
                    });

                    thisBtn.prop("disabled",false);
                    thisBtn.find(".indicator-label").show();
                    thisBtn.find(".indicator-progress").hide();
                }
            });
        }


    }

    forgotPass(e){
        e.preventDefault();
        var thisForm = $(e.target);
        var thisBtn = thisForm.find('button');

        thisForm.find('.error').hide();
        thisBtn.prop("disabled",true);
        thisBtn.find(".indicator-label").hide();
        thisBtn.find(".indicator-progress").show();


        var formData = {
            "action":"forgotpass",
            "email":$('input[name="email"]').val(),
            "language":ootlahData.language,
            "nonce": $('#forgot_pass_nonce').val()
        };

        $.ajax({
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',ootlahData.nonce);
            },
            dataType: "json",
            url: ootlahData.root_url + '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: formData,
            success: (response) => {
                if(response.result=="success"){
                    window.location = ootlahData.root_url+'/'+ootlahData.language+'/forgot-password.html?reset=true';
                }else{
                    $.each(response.errors,function(key,value){
                        if (value != "") {
                            jQuery(".error-"+key).show();
                            jQuery(".error-"+key).find('span.text').text(value);
                        }
                    });
                }

                thisBtn.prop("disabled",false);
                thisBtn.find(".indicator-label").show();
                thisBtn.find(".indicator-progress").hide();
                
            },
            error: (response) => {
                console.log("Sorry");
                console.log(response);
            }
        });
    }

    sendPIN(e){
        e.preventDefault();
        var thisForm = $(e.target);
        var thisBtn = thisForm.find('button');

        thisForm.find('.error').hide();
        thisBtn.prop("disabled",true);
        thisBtn.find(".indicator-label").hide();
        thisBtn.find(".indicator-progress").show();
        var formData = {
            "action":"sendpin",
            "code":$('input[name="code"]').val(),
            "option_send":$('select[name="option_send"]').val(),
            "country_code":$('select[name="country_code"]').val(),
            "phone_number":$('input[name="phone_number"]').val(),
            "language":ootlahData.language,
            "nonce": thisForm.find('input[name="signup_send_pin_nonce"]').val()
        };

        $.ajax({
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',ootlahData.nonce);
            },
            dataType: "json",
            url: ootlahData.root_url + '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: formData,
            success: (response) => {
                if(response.result=="success"){
                    location.reload();
                }else{
                    $.each(response.errors,function(key,value){
                        if (value != "") {
                            jQuery(".error-"+key).show();
                            jQuery(".error-"+key).find('span.text').text(value);
                        }
                    });
                }

                thisBtn.prop("disabled",false);
                thisBtn.find(".indicator-label").show();
                thisBtn.find(".indicator-progress").hide();
                
            },
            error: (response) => {
                console.log("Sorry");
                console.log(response);
            }
        });
    }

    avoidDeletionCountryCode(e){
        var $phoneField = $(e.target);
        var countryCode = $('#phone_number_country').find('select').val()+" ";
        var charCode = (e.which) ? e.which : e.keyCode

        // Set initial value with country code if it's not already there
        if (!$phoneField.val().startsWith(countryCode)) {
            $phoneField.val(countryCode);
        }

        // Prevent backspace or delete on the country code
        //$phoneField.on('keydown', function(event) {
            const cursorPosition = $phoneField.selectionStart;

            // Allow backspace or delete only if cursor is past the country code
            if ((charCode === 8) && cursorPosition <= countryCode.length) {
            e.preventDefault();
            }
        //});

        // Reinsert the country code if user tries to delete it entirely
        //$phoneField.on('input', function() {
            if (!$($phoneField).val().startsWith(countryCode)) {
            $($phoneField).val(countryCode);
            }
        //});
    }

    assignCountryCode(e){
        var thisField = $(e.target);
        jQuery('input[name="phone_number"]').val(thisField.val());
    }
    showMobileNumberField(e){
        var thisField = $(e.target);

        if(thisField.val()==2 || thisField.val()==3){
            $('#phone-number-option').show();
        }else{
            $('#phone-number-option').hide();
        }

    }

    pinInput(e){
        var thisField = $(e.target);
        var charCode = (e.which) ? e.which : e.keyCode

        // if(!this.isNumberKey(e)){
        //     thisField.val('');
        //     return;
        // }

        console.log("hello");

        if (thisField.length == 1 && this.isNumberKey(e) && charCode!=8) {
			$(thisField).next(".pincode-field").focus();
		}else if(charCode==8){
            $(thisField).prev(".pincode-field").focus();
        }

        //$(thisField).prev(".pincode-field").focus();

        if($('#pincode1').val()!=="" && $('#pincode2').val()!=="" && $('#pincode3').val()!=="" && $('#pincode4').val()!==""){
            
            var formData = {
                "action":"signup_verification",
                "code":$('input[name="code"]').val(),
                "pin":$("#pincode-field-main").find('.pincode-field').map(function(){return this.value;}).get(),
                "language":ootlahData.language,
                "nonce": $('input[name="signup_verification_nonce"]').val()
            };

            $("#pincode-field-main").find('.pincode-field').attr("disabled",true);
            $('#verify-loader').html(`<span class="indicator-progress">Verifying...<span class="spinner-border text-success spinner-border-sm align-middle ms-2"></span></span>`);
            $('span.error').fadeOut(300);
            $.ajax({
                beforeSend: (xhr) => {
                    xhr.setRequestHeader('X-WP-Nonce',ootlahData.nonce);
                },
                dataType: "json",
                url: ootlahData.root_url + '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: formData,
                success: (response) => {
                    if(response.result=="success"){
                        location.reload();
                    }else{
                        $.each(response.errors,function(key,value){
                            if (value != "") {
                                jQuery(".error-"+key).show();
                                jQuery(".error-"+key).find('span.text').text(value);
                            }
                        });
                    }
                    $("#pincode-field-main").find('.pincode-field').attr("disabled",false);
                    $('#verify-loader').html(`Enter your PIN here`);
                },
                error: (response) => {
                    console.log("Sorry");
                    console.log(response);
                }
            });

            
        }
    }

    signUpDefault(e){
        e.preventDefault();
        var thisForm = $(e.target);
        const form = document.getElementById('signUpEmailForm');
        const submitButton = document.getElementById('signUpEmailForm_submit');
        thisForm.find('.invalid-feedback').remove();
        thisForm.find('.error').hide();
        //var redirectUrl = thisForm.find('input[name="redirect"]').val();
        
        // Show loading indication
        submitButton.setAttribute('data-kt-indicator', 'on');
        // Disable button to avoid multiple click
        submitButton.disabled = true;

        var validator = FormValidation.formValidation(
            form,
            {
                fields: {
                    'first_name': {
                        validators: {
                            notEmpty: {
                                message: 'First Name is required'
                            }
                        }
                    },
                    'last_name': {
                        validators: {
                            notEmpty: {
                                message: 'Text input is required'
                            }
                        }
                    },
                    'email_address': {
                        validators: {
                            emailAddress: {
                                message: 'The value is not a valid email address'
                            },
                            notEmpty: {
                                message: 'Text input is required'
                            }
                        }
                    },
                    'new_password': {
                        validators: {
                            notEmpty: {
                                message: 'The password is required'
                            },
                            stringLength: {
                                min: 8,
                                max: 30,
                                message: 'The password must be more than 8 and less than 30 characters long'
                            },
                            callback: {
                                message: 'Please enter valid password',
                                callback: function (input) {
                                    if (input.value.length > 0) {
                                        return validatePassword();
                                    }
                                }
                            }
                        }
                    },
                    'confirm_password': {
                        validators: {
                            notEmpty: {
                                message: 'The password confirmation is required'
                            },
                            identical: {
                                compare: function () {
                                    return form.querySelector('[name="new_password"]').value;
                                },
                                message: 'The password and its confirm are not the same'
                            }
                        }
                    }
                },
        
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',
                        eleValidClass: ''
                    })
                }
            }
        );

        if(validator){
            validator.validate().then(function (status) {
                if(status === 'Valid'){
                    var formData = {
                        "action":"signup",
                        "first_name":thisForm.find('input[name="first_name"]').val(),
                        "last_name":thisForm.find('input[name="last_name"]').val(),
                        "email":thisForm.find('input[name="email_address"]').val(),
                        "new_password":thisForm.find('input[name="new_password"]').val(),
                        "confirm_password":thisForm.find('input[name="confirm_password"]').val(),
                        "language":ootlahData.language,
                        "nonce": thisForm.find('input[name="signup_nonce"]').val()
                    };

                    $.ajax({
                        beforeSend: (xhr) => {
                            xhr.setRequestHeader('X-WP-Nonce',ootlahData.nonce);
                        },
                        dataType: "json",
                        url: ootlahData.root_url + '/wp-admin/admin-ajax.php',
                        type: 'POST',
                        data: formData,
                        success: (response) => {
                            if(response.result=="success"){

                                window.location = response.link;
                            }else{
                                Swal.fire({
                                    text: "Error found. Please check.",
                                    icon: "error",
                                    buttonsStyling: false,
                                    confirmButtonText: "Ok, got it!",
                                    customClass: {
                                        confirmButton: "btn btn-danger"
                                    }
                                });

                                setTimeout(function () {
                                    // Remove loading indication
                                    submitButton.removeAttribute('data-kt-indicator');
                                    // Enable button
                                    submitButton.disabled = false;
                                },1000);

                                $.each(response.errors,function(key,value){
                                    if (value != "") {
                                        jQuery(".error-"+key).show();
                                        jQuery(".error-"+key).find('span.text').text(value);
                                    }
                                });
                            }
                            
                        },
                        error: (response) => {
                            console.log("Sorry");
                            console.log(response);
                        }
                    });
                }else{
                    Swal.fire({
                        text: "Error found. Please check.",
                        icon: "error",
                        buttonsStyling: false,
                        confirmButtonText: "Ok, got it!",
                        customClass: {
                            confirmButton: "btn btn-danger"
                        }
                    });

                    setTimeout(function () {
                        // Remove loading indication
                        submitButton.removeAttribute('data-kt-indicator');
                        // Enable button
                        submitButton.disabled = false;
                    },1000);
                }
            });

            
        }
    }
    loginDefault(e){
        e.preventDefault();
        var thisForm = $(e.target);
        const form = document.getElementById('loginEmailForm');
        const submitButton = document.getElementById('loginEmailForm_submit');
        thisForm.find('.invalid-feedback').remove();
        var redirectUrl = thisForm.find('input[name="redirect"]').val();
        var pendingAction = $('#pending_action').val();
        
        // Show loading indication
        submitButton.setAttribute('data-kt-indicator', 'on');
        // Disable button to avoid multiple click
        submitButton.disabled = true;
        var validator = FormValidation.formValidation(
            form,
            {
                fields: {
                    'email': {
                        validators: {
                            notEmpty: {
                                message: 'Text input is required'
                            }
                        }
                    },
                    'password': {
                        validators: {
                            notEmpty: {
                                message: 'Text input is required'
                            }
                        }
                    }
                },
        
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',
                        eleValidClass: ''
                    })
                }
            }
        );

        if(validator){
            validator.validate().then(function (status) {
                if(status === 'Valid'){
                    var formData = {
                        "action":"login",
                        "username":thisForm.find('input[name="email"]').val(),
                        "password":thisForm.find('input[name="password"]').val(),
                        "pending_action": pendingAction,
                        "nonce": $('input[name="login_nonce"]').val()
                    };
                    
                    $.ajax({
                        beforeSend: (xhr) => {
                            xhr.setRequestHeader('X-WP-Nonce',ootlahData.nonce);
                        },
                        dataType: "json",
                        url: ootlahData.root_url + '/wp-admin/admin-ajax.php',
                        type: 'POST',
                        data: formData,
                        success: (response) => {
                            if(response.result=="success"){
                                if(pendingAction=='checkout'){
                                    window.location = ootlahData.root_url+'/'+ootlahData.language+'/checkout.html?ref='+response.ref_link_code+'&oth='+response.oth+'&nocache='+response.nocache;
                                }else{
                                    if (redirectUrl.includes("?")) {
                                        window.location = redirectUrl+'&nocache='+response.nocache;
                                    }else{
                                        window.location = redirectUrl+'?nocache='+response.nocache;
                                    }
                                    
                                }
                                
                            }else{
                                $.each(response.errors,function(key,value){
                                    if (value != "") {
                                        jQuery(".error-"+key).show();
                                        jQuery(".error-"+key).find('span.text').text(value);
                                    }
                                });
                            }
                            
                        },
                        error: (response) => {
                            console.log("Sorry");
                            console.log(response);
                        }
                    });
                }else{
                    Swal.fire({
                        text: "Error found. Please check.",
                        icon: "error",
                        buttonsStyling: false,
                        confirmButtonText: "Ok, got it!",
                        customClass: {
                            confirmButton: "btn btn-danger"
                        }
                    });
                }
            });

            setTimeout(function () {
                // Remove loading indication
                submitButton.removeAttribute('data-kt-indicator');
    
                // Enable button
                submitButton.disabled = false;
            },1000);
        }

    }

    isNumberKey(evt){
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if (charCode > 31 && (charCode < 48 || charCode > 57)) // numbers only
        //if(charCode > 31 && (charCode != 46 &&(charCode < 48 || charCode > 57)))
            return false;
        return true;
    }
}

export default Authentication